module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/66YBFY/tc-custom/9781612438481.jpg?1705065590673",
      "alt": "This image is the cover for the book Brush Pen Lettering Practice Book"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Brush Pen Lettering Practice Book\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Practice your brush pen lettering til you’re perfect with expert drills, tips, and exercises.")]), _c('br'), _c('br'), _vm._v("If you want to take your hand lettering to the next level, you need to practice, practice, practice. But merely writing the same letter over and over often leads to repeating the same mistake instead of improving your skill."), _c('br'), _c('br'), _vm._v("Packed with expert drills, tips and exercises, "), _c('i', [_vm._v("Brush Pen Lettering Practice Book")]), _vm._v(" provides the smart coaching and blank workspace to make your daily practice easier, more efficient and more fun. It’s the ideal way to speed you on your way to creating gorgeous lettering styles."), _c('br'), _c('br'), _vm._v("The perfect companion to author Grace Song’s "), _c('i', [_vm._v("Brush Pen Lettering")]), _vm._v(", this handy workbook features helpful practice pages with guided lines, hints and even specific letter form combinations for many popular words, including:"), _c('br'), _c('br'), _vm._v("• Congratulations"), _c('br'), _c('br'), _vm._v("• Greetings"), _c('br'), _c('br'), _vm._v("• Wedding"), _c('br'), _c('br'), _vm._v("• Happy Birthday\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Grace Song\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0